export default __webpack_public_path__ + "static/media/microsoft-word-seeklogo.com.43d97991.svg";